import { useQuery } from '@tanstack/react-query';

import { DATA_INIT_CACHING } from '@/configs/query';
import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useSharedLegalApi } from '@/features/api/hooks/shared-legal/useSharedLegalApi';

export const useGetCurrentLegalTexts = () => {
  const api = useSharedLegalApi();

  return useQuery({
    queryKey: [API_CACHE_KEYS.LEGAL_TEXTS],
    queryFn: () => api.getCurrentLegalTexts(),
    ...DATA_INIT_CACHING
  });
};
